import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-switch-page',
    templateUrl: './switch-page.component.html',
    styleUrls: ['./switch-page.component.scss'],
    standalone: false
})
export class SwitchPageComponent {
  @Input() pages?: { name: string; route: string }[];
  @Input() parent?: string = '';

  public selectedPage = { name: '', route: '' };

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (this.router.url.toString()) {
        let currentRoute = this.router.url.toString();

        if (this.parent) {
          // Fetch route from local storage if parent is provided
          const storedRoute = localStorage.getItem(this.parent);
          if (storedRoute) {
            currentRoute = storedRoute;
          }
        }

        if (this.pages?.length && currentRoute) {
          this.selectedPage = this.pages.find(
            (page) => page.route === currentRoute
          ) ?? { name: '', route: '' };
        } else if (this.pages?.length){
          this.selectedPage = this.pages.find(
            (page) => page.route === router.url.toString()
          ) ?? { name: '', route: '' };
        }
      }
    });
  }

  public onChange(event: any) {
    this.router.navigate([event.route]);
    if(this.parent){
      localStorage.setItem(this.parent, event.route);
    }
  }
}
